<template>
  <span>
    <v-btn v-if="tipoBtn == 1" color="info" small @click="CargarDatos()" :loading="cargandoDatos" :disabled="!id">
      <v-icon left small>
        {{ icons.mdiFilePdfBox }}
      </v-icon>
      PDF
    </v-btn>

    <v-tooltip bottom v-else>
      <template v-slot:activator="{ on, attrs }">
        <a class="pr-1" v-bind="attrs" v-on="on" @click="CargarDatos()">
          <v-icon color="primary">{{ icons.mdiFilePdfBox }}</v-icon>
        </a>
      </template>
      <span>PDF</span>
    </v-tooltip>
    <Pdf ref="pdfRef"></Pdf>
    <v-dialog v-model="dialogTipoPrint" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Tipo de moneda </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-card class="d-flex align-center primary" height="100" @click="GetPdf(false)">
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center white--text">Moneda Factura</div>
                </v-scroll-y-transition>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="d-flex align-center primary" height="100" @click="GetPdf(true)">
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center white--text">Moneda Principal</div>
                </v-scroll-y-transition>
              </v-card>
            </v-col>
          </v-row>

          <v-divider></v-divider>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" small @click="dialogTipoPrint = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import CompraServices from '@/api/servicios/inventario/CompraServices'
import { mdiFilePdfBox } from '@mdi/js'
import { ref } from '@vue/composition-api'
import FuncionesGenerales from '@/funciones/funciones'
import Pdf from '@/components/PdfFormatoLibreDocumentos.vue' 
export default {
  props: {
    id: Number,
    tipoBtn: {
      type: Number,
      default: 1,
    },
  },
  components: {
    Pdf,
  },
  setup(props) {
    const dialogTipoPrint = ref(false)
    const cargandoDatos = ref(false)
    const pdfRef = ref(null)
    let datoInit = {} 
    let verReal = false


    const monedaSimbolo = () => {
      let simbolo = '$'
      /*if (datoInit.moneda && !verReal) {
        simbolo = datoInit.moneda.simbolo
      }*/
      return simbolo
    }
    const monedaValor = _dato => {
      let valor = _dato
     /* if (datoInit.moneda && !verReal) {
        valor = valor * datoInit.tasa
      }*/
      return valor
    }
    const monedaValorReal = _dato => {
      let valor = _dato
      if (datoInit.moneda) {
        valor = valor / datoInit.tasa
      }
      return valor
    }


    const CargarDatos = () => {
      CompraServices.productoOrdenCompraListarPaginado({ id: props.id })
        .then(response => {
          console.log(response)
          if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
            datoInit = response.data.datos.datos[0]
            GetPdf()
            /*if (datoInit.moneda.actual == true) {
              GetPdf()
            } else {
              dialogTipoPrint.value = true
            }*/
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          cargandoDatos.value = false
        })
    }
    const colorEstatus = item => {
      switch (item) {
        case 89:
          return '#003CCF'
          break
        case 90:
          return '#FF0000'
          break
        case 91:
          return '#FF0000'
          break
        case 92:
          return '#00C806'
          break
        default:
          return '#B2B2B2'
          break
      }
    }
    const GetPdf = (_valor) => {

      verReal = _valor

      dialogTipoPrint.value = false
      const cuerpoTablaDetalles = []

      datoInit.productos.forEach(item => {
        cuerpoTablaDetalles.push([
          item.producto.id.toString(),
          item.producto.nombre,
          FuncionesGenerales.formatoNumeric(item.cantidad),
          monedaSimbolo() +'.'+ FuncionesGenerales.formatoNumeric(monedaValor(item.costo_unidad)),
          FuncionesGenerales.formatoNumeric(item.impuesto) + '%',
          FuncionesGenerales.formatoNumeric(item.descuento) + '%',
          FuncionesGenerales.formatoNumeric(item.iva) + '%',
          monedaSimbolo() +'.'+ FuncionesGenerales.formatoNumeric(monedaValor(item.costo_total)), 
        ])
      })

      const datosInit = {
        cabecera1: { visible: true },
        nombreDocumento: `Orden Compra: ${datoInit.numero_documento}`,
        etiqueta: {
            visible: true,
            valor: datoInit.estado_json.descripcion,
            color: colorEstatus(datoInit.estado_json.id),
        },
        numeroDocumento: {
          texto: 'Orden Compra: ',
          valor: datoInit.id.toString(),
        },
        numeroControl: {
          texto: '',
          valor: datoInit.numero_documento,
        },
        numeroFecha: {
          texto: 'Fecha Creacion',
          valor: FuncionesGenerales.formatoFecha(datoInit.fecha, 1),
        },
        sub1: {
          linea1: [
            { texto: 'Proveedor:', valor: datoInit.proveedor.nombre },
            { texto: 'Rif:', valor: datoInit.proveedor.documento },
            { texto: 'Telf:', valor: datoInit.proveedor.telefono },
            { texto: 'Direccion:', valor: datoInit.proveedor.direccion },
          ],
          linea2: [],
        },
        sub2: {
          linea1: [
           
            {
              texto: 'Area:',
              valor: datoInit.puesto.nombre,
            },
            { texto: 'Almacen:', valor: datoInit.almacen.descripcion },
            { texto: 'Estado:', valor: datoInit.estado_json.descripcion }, 
          ],
          linea2: [
            {
              texto: 'Empleado:',
              valor: datoInit.empleado_json.nombre + ' ' + datoInit.empleado_json.apellido,
            },
            { texto: 'Fecha Vencimiento:', valor: FuncionesGenerales.formatoFecha(datoInit.fecha_vencimiento, 1) },
            {
              texto: 'Hora Creacion:',
              valor: FuncionesGenerales.formatoFecha(datoInit.fecha, 2)
                .replace(/\u00a0/g, '')
                .replace(/\u202f/g, ''),
            },
            
          ],
        },

        pie: {
          nota: {
            texto: 'Observacion:',
            valor: datoInit.observacion,
          },
          totales: [
            {
              texto: 'SubTotal:',
              valor: monedaSimbolo() +'.'+ FuncionesGenerales.formatoNumeric(monedaValor(datoInit.subtotal)),
            },
            {
              texto: 'Impuesto:',
              valor: monedaSimbolo() +'.'+ FuncionesGenerales.formatoNumeric(monedaValor(datoInit.impuesto)),
            },
            {
              texto: 'IVA:',
              valor: monedaSimbolo() +'.'+ FuncionesGenerales.formatoNumeric(monedaValor(datoInit.iva)),
            },
            {
              texto: 'Descuento:',
              valor: monedaSimbolo() +'.'+FuncionesGenerales.formatoNumeric( monedaValor(datoInit.descuento)),
            },
            {
              texto: 'Total:',
              valor: monedaSimbolo() +'.'+ FuncionesGenerales.formatoNumeric(monedaValor(datoInit.total)),
            },
            
            
          ],
        },

        detalles: {
          cabecera: [
            { texto: 'Id', posicion: '45', alineacion: 'left' },
            {
              texto: 'Producto',
              posicion: '80',
              alineacion: 'left',
              justificar: { maxWidth: 130, align: 'justify', maximoItems: 33 },
            },
            { texto: 'Cant', posicion: '240', alineacion: 'right' },
            { texto: 'CostUnd', posicion: '300', alineacion: 'right' },
            { texto: 'Imp', posicion: '360', alineacion: 'right' },
            { texto: 'Des', posicion: '400', alineacion: 'right' },
            { texto: 'IVA', posicion: '460', alineacion: 'right' },
            { texto: 'Total', posicion: '500', alineacion: 'right' }, 
          ],
          cuerpo: cuerpoTablaDetalles,
        },
      }

      

      if (datoInit.estado == 35) {
        datosInit.sub2.linea1.push({
          texto: 'Empleado Anula:',
          valor: datoInit.empleado_anula_json.nombre + ' ' + datoInit.empleado_anula_json.apellido,
        })
        datosInit.sub2.linea2.push({
          texto: 'Fecha Anulacion:',
          valor: FuncionesGenerales.formatoFecha(datoInit.fecha_anulacion, 2),
        })
      }
       

      console.log('datosInit', datosInit)
      pdfRef.value.generarPDF(datosInit)
    }

    return {
      GetPdf,
      cargandoDatos,
      pdfRef,
      dialogTipoPrint,
      icons: {
        mdiFilePdfBox,
      },
      CargarDatos,
       
    }
  },
}
</script>